import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "../../../assets/style/pageStyle/statistics.scss";
import LineChart from "../Chart/LineChart";
import {
  exportReportChat,
  getReportChat,
  getReportLineChat,
} from "../../../services/slice/statisticsSlice";
import { Row } from "antd";
import { useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
import TableStatisticChat from "../Table/TableStatisticChat";
import HeaderStatisticChat from "../HeaderStatisticChat";
import moment from "moment";
import TranslateText from "../TranslateText";
const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const TabStaffChatUp = ({ type }) => {
  const dispatch = useDispatch();
  const statisticsState = useSelector(statisticsSelector);
  const { dataSatisticsMessage, dataSatisticsChartMessage } = statisticsState;
  // const { content, dataExportMessage } = dataSatisticsMessage;
  const [config, setConfig] = useState({
    timeStart: moment().subtract(3, "month").startOf("day").format(dateFormat),
    timeEnd: moment().endOf("day").format(dateFormat),
    size: 10,
    page: 0,
  });
  useEffect(() => {
    dispatch(
      getReportLineChat({
        timeStart: new Date(config.timeStart).getTime() / 1000,
        timeEnd: new Date(config.timeEnd).getTime() / 1000,
      })
    );
  }, [type, dispatch, config.timeEnd, config.timeStart]);

  useEffect(() => {
    dispatch(
      getReportChat({
        timeStart: new Date(config.timeStart).getTime() / 1000,
        timeEnd: new Date(config.timeEnd).getTime() / 1000,
        size: config.size,
        page: config.page,
      })
    );
  }, [type, dispatch, config]);

  const selectedLabels =
    type === "staffChatUp"
      ? staffChatUpLabels
      : type === "staffChatDown"
      ? staffChatDownLabels
      : type === "totalChat"
      ? totalChat
      : [];

  const labels = dataSatisticsChartMessage
    ? dataSatisticsChartMessage?.map((item) =>
        item.weekNumber
          ? `Tuần ${item.weekNumber}`
          : `Tháng ${item.monthNumber}`
      )
    : [];

  const display = Object.values(selectedLabels).map((field) => {
    return dataSatisticsChartMessage
      ? dataSatisticsChartMessage?.map((item) => item[field])
      : [];
  });

  const [hiddenLines, setHiddenLines] = useState([]);

  const handleExportExcel = () => {
    dispatch(
      exportReportChat({
        timeStart: new Date(config.timeStart).getTime() / 1000,
        timeEnd: new Date(config.timeEnd).getTime() / 1000,
      })
    );
  };

  return (
    <div className="wrapperAccessPost">
      <Row className="headerPage">
        <HeaderStatisticChat
          config={config}
          handleExport={handleExportExcel}
          title={
            type === "staffChatUp"
              ? "Thống kê số liệu tin nhắn khách hàng chat lên Bkav"
              : type === "staffChatDown"
              ? "Thống kê số liệu tin nhắn nhân viên chat xuống Bkav"
              : type === "totalChat"
              ? "Thống kê số liệu phiên chat Bkav "
              : ""
          }
          setConfig={setConfig}
        />
      </Row>
      <TableStatisticChat type={type} setConfig={setConfig} config={config} />
      <div className="chartStatistics mt-5">
        <Row className="headerPage mt-5">
          <Row className="headerPage">
            <h2 className="title">
              <TranslateText text={"Biểu đồ tỷ lệ phản hồi Chat với My Bkav"} />
            </h2>
          </Row>
        </Row>
        <LineChart
          titleToolTip={Object.keys(selectedLabels)}
          listColor={listColor}
          labels={labels}
          dataIn={display}
          hiddenLines={hiddenLines}
          tooltipChat={true}
        />

        <div className="listLabelStatistic">
          {Object.keys(selectedLabels).map((item, index) => {
            const isHidden = hiddenLines.includes(index);
            return (
              <div
                key={index}
                className="labelItem"
                style={{ opacity: isHidden ? 0.4 : 1, cursor: "pointer" }}
                onClick={() => {
                  setHiddenLines((prev) =>
                    prev.includes(index)
                      ? prev.filter((i) => i !== index)
                      : [...prev, index]
                  );
                }}
              >
                <span
                  className="dotLabel"
                  style={{
                    backgroundColor: listColor[index],
                    opacity: isHidden ? 0.4 : 1,
                  }}
                ></span>
                {item}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TabStaffChatUp;

export const listColor = ["#047DE7", "#E7042A", "#47E021", "#ED1C24"];
export const staffChatUpLabels = {
  "NV đã trả lời": "agentMessageRespondedCount",
  "NV đã đọc": "agentMessageReadNotRespondedCount",
  "NV chưa đọc": "agentMessageUnreadCount",
};
export const staffChatDownLabels = {
  "KH đã trả lời": "customerMessageRespondedCount",
  "KH đã đọc": "customerMessageReadNotRespondedCount",
  "KH chưa đọc": "customerMessageUnreadCount",
};
export const totalChat = {
  "NV chủ động chat xuống": "agentMessageCount",
  "KH chủ động chat lên": "customerMessageCount",
};
